<template>
	<div class="index">
		<div class="index-con">
			<div class="detail">
				<div class="detail-title">
					upload final paper
				</div>
				<div class="p-20">
					<div class="detail-tip">
						Please upload the final paper (doc\docx)
					</div>

					<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
						:on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple
						:limit="3" :on-exceed="handleExceed" :file-list="fileList">
						<el-button size="small" type="success">Selet final paper</el-button>
						<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
					</el-upload>
					<p class="p-tip">The proof of copyright is not necessary</p>
					<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
						:on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple
						:limit="3" :on-exceed="handleExceed" :file-list="fileList">
						<el-button size="small" type="success">Selet Copyright paper</el-button>
						<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
					</el-upload>
					<div class="sub-mit">
						submit final paper
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fileList: [{
					name: 'food.jpeg',
					url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
				}, {
					name: 'food2.jpeg',
					url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
				}]
			};
		},
		methods: {
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			}
		}
	}
</script>

<style scoped>
	.index-con {
		width: 1200px;
		margin: 40px auto;
	}

	.detail {
		border: 1px solid #ddd;
		border-radius: 4px;
	}

	.p-20 {
		padding: 20px;
		box-sizing: border-box;
	}

	.detail-title {
		background: #f5f5f5;
		padding: 15px;
		font-size: 18px;
		font-weight: 600;
		box-sizing: border-box;
	}

	.detail-tip {
		padding: 10px;
		box-sizing: border-box;
		border-radius: 4px;
		background: #dff0d8;
		margin-bottom: 20px;
	}

	.p-tip {
		margin: 10px 0 20px;
	}

	.sub-mit {
		color: #fff;
		background-color: #428bca;
		border-color: #357ebd;
		padding: 10px 26px;
		font-size: 16px;
		border-radius: 6px;
		margin-top: 20px;
		display: inline-block;
	}

	@media screen and (max-width: 768px) {
		.index-con {
			width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/login/uploadPaperDetail.vue